(
  window as unknown as { __zone_symbol__UNPATCHED_EVENTS: string[] }
).__zone_symbol__UNPATCHED_EVENTS = [
  "scroll",
  "mousemove",
  "touchmove",
  "mousewheel",
];
